import type { GetStaticProps, NextPage } from "next";
import { InquiryPage } from "src/domains/shared/components/Home/Inquiry/InquiryPage";
import { SiteLayout } from "src/domains/shared/components/Home/SiteShell/SiteLayout";

const Inquiry: NextPage = () => (
  <SiteLayout>
    <InquiryPage />
  </SiteLayout>
);

export const getStaticProps: GetStaticProps = () => {
  return {
    props: {},
  };
};

export default Inquiry;
